import * as $p5js_gleam from "../p5js_gleam/p5js_gleam.mjs";
import * as $p5 from "../p5js_gleam/p5js_gleam/bindings.mjs";
import { CustomType as $CustomType } from "./gleam.mjs";
import * as $vector from "./vector.mjs";

/**
 * Represents a hole in the ground that things can fall into.
 */
export class Pit extends $CustomType {
  constructor(position, size) {
    super();
    this.position = position;
    this.size = size;
  }
}
export const Pit$Pit = (position, size) => new Pit(position, size);
export const Pit$isPit = (value) => value instanceof Pit;
export const Pit$Pit$position = (value) => value.position;
export const Pit$Pit$0 = (value) => value.position;
export const Pit$Pit$size = (value) => value.size;
export const Pit$Pit$1 = (value) => value.size;

/**
 * Renders the pit to the screen
 */
export function draw(p, pit) {
  let _pipe = $p5.no_stroke(p);
  let _pipe$1 = $p5.fill(_pipe, "#969696");
  let _pipe$2 = $p5.circle(
    _pipe$1,
    pit.position.x - 2.0,
    pit.position.y - 2.0,
    pit.size + 1.0,
  );
  let _pipe$3 = $p5.fill(_pipe$2, "#3C3C3C");
  let _pipe$4 = $p5.circle(
    _pipe$3,
    pit.position.x - 1.0,
    pit.position.y - 1.0,
    pit.size + 1.0,
  );
  let _pipe$5 = $p5.fill(_pipe$4, "#000000");
  return $p5.circle(_pipe$5, pit.position.x, pit.position.y, pit.size * 2.0);
}
